/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { NgModule } from '@angular/core';

import { newConfig } from './shared.custom-config';

// You can modify or replace module config here

@NgModule(newConfig)
export class SharedModule { }



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/shared.module.ts